import { MuiCard, dfdDefaultTheme } from 'theme/material-ui';
import styled from 'styled-components';
import { FlexBoxRow } from 'components/UI/Layout/FlexBox';
import { spacings } from 'modules/utils/StylesUtils';

import { HIDE_IMAGE_BREAKPOINT } from 'modules/constants/ConnectCare';

export const ImgBox = styled(FlexBoxRow)`
  width: 275px;
  height: 265px;

  ${dfdDefaultTheme.breakpoints.down('sm')} {
    padding: ${spacings(2, 3)};
  }
`;

export const MuiHomeCard = styled(MuiCard)`
  &&& {
    display: flex;
    flex-direction: row;
    ${dfdDefaultTheme.breakpoints.up(HIDE_IMAGE_BREAKPOINT)} {
      max-height: 265px;
    }
    ${dfdDefaultTheme.breakpoints.down('sm')} {
      flex-direction: column;
    }
  }
`;
